import { syncOrchestrator } from "../api/services/syncOrchestrator";

export const forceSyncNow = (reason = "manual") => {
  if (!syncOrchestrator.disabled) {
    syncOrchestrator.markDirty();
    syncOrchestrator.forceSyncNow(reason);
  }
};
